import { useTranslation } from 'react-i18next';
import lang from './es/es-CL.json';

const dict = lang.translation;
type DictionaryObject = { [K: string]: string };

interface TypedTFunction<D extends DictionaryObject> {
	<K extends keyof D>(args: K): D[K];
}

export function useTypedTranslation(): { t: TypedTFunction<typeof dict> } {
	const { t } = useTranslation();
	return {
		t(...keys: string[]) {
			return t(keys.join('.'));
		}
	};
}
